module.exports = __webpack_public_path__ + "img/pm.cf5ef40e.webp";